import { validateDownload } from '@/services/chat';
import { bridgeCallFunc } from '@/utils/instantLoaded/tools';
import initStore from '@/stores/init';
import * as Toast from '@/utils/Toast';

export const previewWithBridge = async (url: string, fileName: string) => {
  const fileKey = getFileKey(url);

  // 取得到 file key 才会校验文件是否有效
  if (fileKey) {
    const res = await validateDownload(fileKey);
    if (res instanceof Error) {
      console.error(res);
      Toast.error(res.message);
      return;
    }
  }
  bridgeCallFunc(() => {
    initStore.UPDATE_DONT_SCROLL_TO_BOTTOM(true);
    window.bridgeCallHandler(
      'previewFile',
      {
        fileName,
        url,
      },
      function (res: any) {
        if (res.error) {
          Toast.error(res.errorMessage);
        }
      },
    );
  });
};

export const getFileKey = (fileUrl: string) => {
  if (!fileUrl) {
    return '';
  }
  // url example: https://chatbot.test.shopee.co.id/chat/v1/download?file_key=373194193068137600_test_id
  // 从 fileUrl search 中获取 fileKey
  try {
    const { searchParams, hostname } = new URL(fileUrl);
    // 只校验通过 chatbot 上传文件
    if (hostname !== location.hostname) {
      return '';
    }
    const fileKey = searchParams.get('file_key');
    return fileKey || '';
  } catch (e) {
    return '';
  }
};
